export const decodeWithUnicode = (str: string): string => {
  if (!str) return '';
  return decodeURIComponent(JSON.parse('"' + str + '"'));
};
